import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import Scenario from "../components/scenario/Scenario";
import ScenarioList from "../components/ScenarioList";

const ScenarioListPage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "سناریوها",
      slug: "planning/scenario-list",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
            <ScenarioList />
        </div>
    </HelmetProvider>
  );
};

export default ScenarioListPage;